import { render } from "./ElementItem.vue?vue&type=template&id=4d961bfa"
import script from "./ElementItem.vue?vue&type=script&lang=js"
export * from "./ElementItem.vue?vue&type=script&lang=js"

import "./ElementItem.vue?vue&type=style&index=0&id=4d961bfa&lang=css"

import exportComponent from "E:\\Data\\Repos\\Propnroll\\Propnroll\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__